const additionalCostGroupText = 'Alguns serviços deste grupo possuem custo adicional e não podem ser marcados automaticamente'
const manualInputGroupText = 'Alguns serviços deste grupo necessitam de inputs adicionais e não podem ser marcados automaticamente. Em caso de dúvida, entre em contato com nosso suporte.'
const manualInputServiceText = 'Este serviço requer o preenchimento de inputs adicionais. Em caso de dúvida, entre em contato com nosso suporte.'
export {
  additionalCostGroupText,
  manualInputGroupText,
  manualInputServiceText,
}
